/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IncomeDto } from './IncomeDto';
import {
    IncomeDtoFromJSON,
    IncomeDtoFromJSONTyped,
    IncomeDtoToJSON,
    IncomeDtoToJSONTyped,
} from './IncomeDto';
import type { GuarantorDto } from './GuarantorDto';
import {
    GuarantorDtoFromJSON,
    GuarantorDtoFromJSONTyped,
    GuarantorDtoToJSON,
    GuarantorDtoToJSONTyped,
} from './GuarantorDto';

/**
 * 
 * @export
 * @interface TenantDto
 */
export interface TenantDto {
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    id?: string;
    /**
     * ID of the real estate property the tenant occupies
     * @type {string}
     * @memberof TenantDto
     */
    realEstateId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    firstName: string;
    /**
     * Date calendaire "yyyy-MM-dd" — string de bout en bout, jamais de Date sérialisé
     * @type {string}
     * @memberof TenantDto
     */
    birthDate: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    civilityId: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    employmentStatusId?: string;
    /**
     * Date calendaire "yyyy-MM-dd" — string de bout en bout, jamais de Date sérialisé
     * @type {string}
     * @memberof TenantDto
     */
    checkInDate: string;
    /**
     * Date calendaire "yyyy-MM-dd" — string de bout en bout, jamais de Date sérialisé
     * @type {string}
     * @memberof TenantDto
     */
    checkOutDate?: string;
    /**
     * Déclaration « à jour de ses loyers » — exigée pour un locataire en place (≥ 6 mois au début du contrat). Null = ne pas modifier la déclaration existante.
     * 
     * @type {boolean}
     * @memberof TenantDto
     */
    rentPaymentsUpToDate?: boolean | null;
    /**
     * 
     * @type {Array<IncomeDto>}
     * @memberof TenantDto
     */
    incomes: Array<IncomeDto>;
    /**
     * 
     * @type {GuarantorDto}
     * @memberof TenantDto
     */
    guarantor?: GuarantorDto;
}

/**
 * Check if a given object implements the TenantDto interface.
 */
export function instanceOfTenantDto(value: object): value is TenantDto {
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('civilityId' in value) || value['civilityId'] === undefined) return false;
    if (!('checkInDate' in value) || value['checkInDate'] === undefined) return false;
    if (!('incomes' in value) || value['incomes'] === undefined) return false;
    return true;
}

export function TenantDtoFromJSON(json: any): TenantDto {
    return TenantDtoFromJSONTyped(json, false);
}

export function TenantDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'realEstateId': json['realEstateId'] == null ? undefined : json['realEstateId'],
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'birthDate': json['birthDate'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'civilityId': json['civilityId'],
        'employmentStatusId': json['employmentStatusId'] == null ? undefined : json['employmentStatusId'],
        'checkInDate': json['checkInDate'],
        'checkOutDate': json['checkOutDate'] == null ? undefined : json['checkOutDate'],
        'rentPaymentsUpToDate': json['rentPaymentsUpToDate'] == null ? undefined : json['rentPaymentsUpToDate'],
        'incomes': ((json['incomes'] as Array<any>).map(IncomeDtoFromJSON)),
        'guarantor': json['guarantor'] == null ? undefined : GuarantorDtoFromJSON(json['guarantor']),
    };
}

export function TenantDtoToJSON(json: any): TenantDto {
    return TenantDtoToJSONTyped(json, false);
}

export function TenantDtoToJSONTyped(value?: TenantDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'realEstateId': value['realEstateId'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'birthDate': value['birthDate'],
        'phone': value['phone'],
        'email': value['email'],
        'civilityId': value['civilityId'],
        'employmentStatusId': value['employmentStatusId'],
        'checkInDate': value['checkInDate'],
        'checkOutDate': value['checkOutDate'],
        'rentPaymentsUpToDate': value['rentPaymentsUpToDate'],
        'incomes': ((value['incomes'] as Array<any>).map(IncomeDtoToJSON)),
        'guarantor': GuarantorDtoToJSON(value['guarantor']),
    };
}

